import React, { useEffect, useState } from "react";
import { AppState, Site, User, UserAttributes } from "../types/types";
import { useAppStore } from "../stores/RootStore";
import { useFetch } from "../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useFetchLicense } from "../hooks/useFetchLicense";
import { publicConfig } from "@/config/publicConfig";

let AuthContext = React.createContext<AppState>(null!);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  let store = useAppStore();
  let value = { ...store };
  const [{ response, error }, doFetchAccount] = useFetch(`/users/account`, true);
  const [{ response: licenseResponse, error: licenseError, statusCode }, doFetchLicenseCheck] =
    useFetchLicense(`/licenses/check`);

  useEffect(() => {
    if (!localStorage.getItem("weld-jwt")) {
      store.setLoading(false);
      return;
    } else doFetchAccount();
  }, [store.isLogged]);

  const navigate = useNavigate();
  // Обработка ошибки 401 и удаление неправильного токена из localStorage
  useEffect(() => {
    if (!error) return;

    if (error.errors[0].status === 401) {
      localStorage.removeItem("weld-jwt");
      navigate("/");
    }
    store.setLoading(false);
  }, [error]);

  useEffect(() => {
    if (!response) return;

    let site = response?.data?.attributes?.sites?.find((s: Site) => s.last_used === true) as unknown as Site;
    if (false)
      // !response?.data?.attributes.admin
      doFetchLicenseCheck({
        method: "POST",
        data: {
          key: site.license_key,
          workplace_key: "test1", // В web версии нельзя получить machine key
        },
      });
    // Отсутствие проверки лицензии для аккаунта администратора
    else {
      store.setCurrentUser(response!.data as unknown as User);
      let site = response?.data?.attributes?.sites?.find((s: Site) => s.last_used === true) as unknown as Site;
      store.setCurrentSite(site);
      store.setLicenseCheck(true);
    }
  }, [response]);

  useEffect(() => {
    if (!publicConfig.licensingEnabled || !licenseResponse) return;
    store.setCurrentUser(response!.data as unknown as User);
    let site = response?.data?.attributes?.sites?.find((s: Site) => s.last_used === true) as unknown as Site;
    store.setCurrentSite(site);
    store.setLicenseCheck(true);
  }, [licenseResponse]);

  useEffect(() => {
    if (!publicConfig.licensingEnabled || !licenseError) return;
    if (statusCode == "404") {
      console.log("Отсутствует такой ключ организации");
    }
    if (statusCode == "403") {
      console.log("Срок лицензии истёк или превышено количество активированных копий");
    }

    store.setCurrentUser(response!.data as unknown as User);
    let site = response?.data?.attributes?.sites?.find((s: Site) => s.last_used === true) as unknown as Site;
    store.setCurrentSite(site);
  }, [licenseError]);

  return <AuthContext.Provider value={value}>{store.loading ? <div></div> : children}</AuthContext.Provider>;
}
